import React, { useState } from "react";
import "./ContextServices.css";

const ContextServices = ({ soapCredentials }) => {
  const [progress, setProgress] = useState([]); // Track progress messages
  const [loading, setLoading] = useState(false);

  const handleStartAutomation = async () => {
    setLoading(true);
    setProgress(["Starting Context Services automation..."]);
    console.log("Starting automation with credentials:", soapCredentials);
    
    try {
      // Placeholder for API call logic
      setProgress(prev => [...prev, "Connecting to Five9 API..."]);
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
      
      setProgress(prev => [...prev, "Building context services configuration..."]);
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setProgress(prev => [...prev, "Configuration completed successfully!"]);
      
    } catch (error) {
      console.error("Error running automation:", error);
      setProgress(prev => [...prev, `Error: ${error.message}`]);
    }
    
    setLoading(false);
  };

  return (
    <div className="technology-selector">
      <div className="container">
        <header className="selector-header">
          <h1>Context Services Build Out</h1>
          <p>Automated configuration for Five9 Context Services</p>
        </header>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '50vh',
          padding: '20px 0'
        }}>
          <div className="technology-card" style={{ 
            maxWidth: '600px',
            width: '100%',
            textAlign: 'left'
          }}>
            <div style={{ marginBottom: '20px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <h3 style={{ margin: '0 0 8px 0', color: '#333' }}>Authenticated User:</h3>
              <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>
                <strong>{soapCredentials?.username || "Not provided"}</strong>
              </p>
            </div>

            {progress.length > 0 && (
              <div style={{ marginBottom: '20px' }}>
                <h4>Progress:</h4>
                <div style={{
                  background: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '4px',
                  padding: '12px',
                  maxHeight: '200px',
                  overflowY: 'auto'
                }}>
                  {progress.map((msg, index) => (
                    <div key={index} style={{ 
                      padding: '4px 0',
                      fontSize: '14px',
                      color: msg.includes('Error') ? '#dc3545' : '#28a745'
                    }}>
                      {msg}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ textAlign: 'center' }}>
              <button 
                onClick={handleStartAutomation}
                disabled={loading}
                className="select-btn"
                style={{ 
                  width: '200px',
                  opacity: loading ? 0.6 : 1,
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? "Running..." : "Start Automation"}
              </button>
            </div>

            {loading && (
              <div style={{ 
                textAlign: 'center', 
                marginTop: '16px',
                color: '#666',
                fontSize: '14px'
              }}>
                Processing... Please wait.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContextServices;